export function nowISO(): string {
  return new Date().toISOString();
}

export function formatTime(ts: number): string {
  return new Date(ts).toLocaleTimeString();
}

export function formatTransmissionTime(date = new Date()): string {
  const MM = String(date.getMonth() + 1).padStart(2, "0");
  const DD = String(date.getDate()).padStart(2, "0");
  const hh = String(date.getHours()).padStart(2, "0");
  const mm = String(date.getMinutes()).padStart(2, "0");
  const ss = String(date.getSeconds()).padStart(2, "0");

  return `${MM}${DD}${hh}${mm}${ss}`;
}